<template>
    <v-dialog
        v-model="$store.state.privateStations.addProduct"
        max-width="500px"
    >
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Add Products</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.privateStations.addProduct = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid v-if="spinner">
                <v-row>
                    <v-col>
                        <v-combobox
                            v-model="product"
                            :items="all"
                            dense
                            label="Products"
                            required
                            :rules="[v => !!v || 'Required']"
                            :item-text="'Product'"
                            :item-value="'ProductID'"
                            @click:append-outer="add()"
                            append-outer-icon="mdi-content-save"
                        >
                        </v-combobox>
                    </v-col>
                </v-row>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th colspan="2">{{ station }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(itm, idx) in products" v-bind:key="idx">
                            <td>{{ itm.Product }}</td>
                            <td>
                                <v-btn
                                    @click="deleteProduct(itm)"
                                    color="red"
                                    icon
                                    dark
                                    ><v-icon>mdi-delete</v-icon></v-btn
                                >
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>
            <v-container grid-list-xs v-else>
                <v-row justify="center" class="mt-3 mb-3">
                    <v-col cols="1">
                        <div class="sk-chase">
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-dialog>
</template>
<script>

import ConfirmDialogue from './../../ConfirmDialogue.vue';
import axios from 'axios';
export default {
    props: ['station'],
    components:{
        ConfirmDialogue
    },
    data: function() {
        return {
            all: [],
            products: [],
            product: [],
            spinner: false
        };
    },
    mounted() {
        this.loadProducts(this.station);
    },
    methods: {
        async dltLastProduct(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'If you unassign this last product, it will no longer appear in this catalog until it is added again.',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.spinner = false;
                this.dltProduct(itm);
            }
        },
        deleteProduct: function(itm) {
            if(this.products.length == 1) {
                this.dltLastProduct(itm);
            }else{
                this.dltProduct(itm)
            }
        },
        dltProduct: function(itm) {
            this.spinner = false;
            var str = this.$store;
            axios
                .delete('product-station-priv/' + itm.Id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'red',
                        text: 'Product Successfully Removed'
                    });
                    this.$store.state.privateStations.watch = true;
                    console.log(response.data);
                    if(this.products.length == 1) {
                        this.$store.state.privateStations.addProduct = false;
                    }
                    this.product = null;
                    this.all.length = 0;
                    this.products.length = 0;
                    this.loadProducts(this.station);
                })
                .catch(function(error) {
                    console.log(error);
                }); 
        },
        loadAllProducts: function() {
            this.$store.state.isLoading = true;
            axios
                .get('product/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.all = response.data.data;
                    this.products.forEach(stt => {
                        this.all.forEach((prd, idx) => {
                            if (stt.ProductID == prd.ProductID) {
                                this.all.splice(idx, 1);
                            }
                        });
                        this.spinner = true;
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        add: function() {
            var str = this.$store;
            if (this.product.ProductID == undefined) {
                str.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Select a product!!'
                });
            } else {
                var parms = {
                    Station: this.products[0].StationID,
                    Product: this.product.ProductID
                };

                this.spinner = false;
                axios
                    .post('product-station-priv', parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.$store.state.privateStations.watch = true;
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Product Save!!'
                        });
                        this.product = null;
                        this.all.length = 0;
                        this.products.length = 0;
                        this.loadProducts(this.station);
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        },
        loadProducts: function(station) {
            this.$store.state.isLoading = true;
            var parms = {
                station: station
            };
            axios
                .post('product-station-priv/station', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.products = response.data;
                    this.loadAllProducts();
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        }
    }
};
</script>
